import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@app/material/material.module';

import { SelectModule } from '@shared/components/form/select/select.module';
import { InputModule } from '@shared/components/form/input/input.module';
import { ButtonModule } from '@shared/components/button/button.module';

import { QuestionnaireDialogComponent } from './questionnaire-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    InputModule,
    ButtonModule
  ],
  declarations: [QuestionnaireDialogComponent],
  entryComponents: [QuestionnaireDialogComponent],
  exports: [QuestionnaireDialogComponent],
})
export class QuestionnaireDialogModule { }
